
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared/media-kits/[id]",
      function () {
        return require("private-next-pages/shared/media-kits/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared/media-kits/[id]"])
      });
    }
  